import "../extensions/number";
export default class AnimatedCounter {
    constructor() {
        this.counters = new Array();
        document.addEventListener('DOMContentLoaded', () => { this.init(); });
    }
    init() {
        let counters = document.querySelectorAll('.animated-counter');
        counters.forEach(c => {
            let data = JSON.parse(c.getAttribute("counter-data"));
            data.Decimals = Math.max(data.StartingNumber.countDecimals(), data.EndingNumber.countDecimals());
            data.Current = data.StartingNumber;
            data.Element = c;
            let steps = 100;
            data.TimerDelay = data.Duration / steps;
            data.Steps = (data.EndingNumber - data.StartingNumber) / steps;
            this.counters.push(data);
            this.render(data);
            setTimeout(() => {
                this.tick(data);
            }, data.Delay);
        });
    }
    tick(counter) {
        if (!counter.Element.inView()) {
            counter.Current = counter.StartingNumber;
        }
        else {
            if (counter.Current < counter.EndingNumber) {
                counter.Current += counter.Steps;
                if (counter.Current > counter.EndingNumber)
                    counter.Current = counter.EndingNumber;
                this.render(counter);
            }
        }
        setTimeout(() => {
            this.tick(counter);
        }, counter.TimerDelay);
    }
    render(counter) {
        counter.Element.innerHTML = "<span class=\"prefix\">" + counter.NumberPrefix + "</span>" + (counter.Decimals == 0 ? Math.round(counter.Current) : counter.Current.toFixed(counter.Decimals)) + "<span class=\"suffix\">" + counter.NumberSuffix + "</span>";
    }
}
class Counter {
}
